import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import gameImge from "../../Assets/images/Image1.png"
import { FaChartPie } from "react-icons/fa";
import { FaCommentDollar } from "react-icons/fa";
import { FaFileInvoiceDollar } from "react-icons/fa";
import "./home.css"
import GameHeader from '../header/header';

const RatingPageOBT = () => {
    let navigate = useNavigate();
    const [items, setItems] = useState([]);

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('items'));
        if (items) {
            setItems(items);
        }
    }, []);
    const handleAdminlogin = () => {
        navigate(`/RatingObtimization`);
    };
    return (
        <div className="bg">
            <GameHeader />
            <div className='py-3'>
                <h5 className='bodhead center'>Data Optimized System</h5>
            </div>
            <div className="marquee-container">
                <div className="marquee-text">
                    Play Smart. Win Big. Work Online and Level Up Your Earnings
                </div>
            </div>
            <div className="image-container p-3">
                <img src={gameImge} className="responsive-img" alt="Game" />
            </div>
            <div className='optimizeBox' >
                <div className='center h5'>Optimization</div>
                <div className='d-flex justify-content-around'>
                    <div>
                        <FaCommentDollar size={20} />
                        <div className='boxtxt'>   Price (USDC)</div>
                    </div>
                    <div><FaChartPie size={20} /></div>
                    <div><FaFileInvoiceDollar size={20} /></div>
                </div>
                <div className='d-flex justify-content-around mt-3'>
                    <div className='boxtxt'>Daily Profit (USDC)</div>
                    <div className='boxtxt'>Data value (USDC)</div>
                </div>
                <div className='d-flex justify-content-around mt-1'>
                    <div className='boxtxt2'>0.00</div>
                    <div className='boxtxt2'>500.00</div>
                </div>
                <div className='center p-3'>
                    <button class="btn btn-scondary  btn-lg " type="button" onClick={handleAdminlogin}>
                        Account
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RatingPageOBT;
